import { Routes } from '@/api/Routes';
import { http } from '@/common/utils/HttpServices';

export interface FilterDemandeIntervention {
    page?: number;
    sort?: string;
    etats?: string[];
    chantierIds?: number[];
    adresseProjetIds?: number[];
    idDemande?: string;
    mesDemandes?: boolean;
    dateDebut?: string;
    dateFin?: string;
    devisId?: number;
    phaseIds?: number[];
    isBim?: boolean;
}

class DemandeInterventionService {
    public async getDemandesIntervention(params: FilterDemandeIntervention, signal?: AbortSignal): Promise<any> {
        return http.get(Routes.DemandeInterventionRoutes.GetDemandesIntervention(), { params: { ...params }, signal });
    }
    public async getDemandeIntervention(id: number): Promise<any> {
        return http.get(Routes.DemandeInterventionRoutes.GetDemandeIntervention(id));
    }
    public async getInterventionsByDemandeInterventionId(id: number): Promise<any> {
        return http.get(Routes.DemandeInterventionRoutes.GetInterventionsByDemandeInterventionId(id));
    }
    public async getPieceJointeById(id: number): Promise<any> {
        return http.get(Routes.DemandeInterventionRoutes.GetPieceJointeById(id), { responseType: 'arraybuffer' });
    }
    public async getExportXlsDemandesIntervention(params: FilterDemandeIntervention): Promise<any> {
        return http.get(Routes.DemandeInterventionRoutes.GetExportXlsDemandesIntervention(), {
            params,
            responseType: 'arraybuffer',
        });
    }
    public async getRapportsPDF(id: number) {
        return http.get(Routes.DemandeInterventionRoutes.GetRapportsDemandeIntervention(), {
            params: { id },
            responseType: 'arraybuffer',
        });
    }
    public async sendAskInterventionReminder(id: number): Promise<any> {
        return http.post(Routes.DemandeInterventionRoutes.SendAskInterventionReminder(id));
    }
    public async supprimerDemandeIntervention(id: number): Promise<any> {
        return http.delete(Routes.DemandeInterventionRoutes.SupprimerDemandesIntervention(id));
    }
}

export default new DemandeInterventionService();
